import { render } from "./WrapWithDropdownBody.vue?vue&type=template&id=36becae6&scoped=true"
import script from "./WrapWithDropdownBody.vue?vue&type=script&lang=js"
export * from "./WrapWithDropdownBody.vue?vue&type=script&lang=js"

import "./WrapWithDropdownBody.vue?vue&type=style&index=0&id=36becae6&lang=scss"
import "./WrapWithDropdownBody.vue?vue&type=style&index=1&id=36becae6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36becae6"]])

export default __exports__